export const readEntryPromise = async (entry) => {
    return new Promise((resolve, reject) => {
        var dirReader = entry.createReader();
        dirReader.readEntries(function (files) {
            resolve(files)
        });
    })
}
export const getFilePromise = async (fileentry) => {
    return new Promise((resolve, reject) => {
        fileentry.file((file) => {
            resolve(file)
        })
    })
}

export const RAW_FILE_TYPES = ['cr2', 'cr3', 'nef', 'dng', 'tif', 'arw', 'xmp']